var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({staticClass:"onboarding-btn-container",class:_vm.type,style:({ width: _vm.width ? `${_vm.width}px` : '', height: _vm.height ? `${_vm.height}px` : '' }),on:{"click":_vm.clickBtn}},'button',_vm.$attrs,false),_vm.$listeners),[(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e(),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }